<!-- eslint-disable @angular-eslint/template/mouse-events-have-key-events -->
<ng-container *ngIf="version">
  <div
    class="version-item-container"
    (mouseover)="isHovered.set(true)"
    (mouseleave)="isHovered.set(false)">
    <mat-icon svgIcon="version" class="version-icon"></mat-icon>
    <div class="version-item-content">
      <span class="version-item-name">
        {{ version | getVersionLabel }}
      </span>
      <q9-tag [color]="version.state | getVersionTagColor">
        {{ version | getVersionName: isAuthorizationActive }}
      </q9-tag>
      <p class="version-item-date">
        {{
          (version.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT
            ? 'ASIDE_R.LAST_MOD'
            : 'ASIDE_R.PUBLISHED_DATE'
          ) | translate
        }}:
        {{ version.updatedAt | date: "MMMM dd, yyyy 'at' HH:mm" }}
        {{ version.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT ? userName : '' }}
      </p>
    </div>
    <button
      *ngIf="version | transform: showMenuButton.bind(this) | async"
      class="q9-icon-btn"
      icon="more"
      type="button"
      mat-button
      [matMenuTriggerFor]="actionsMenu"
      (click)="handleMenuClick($event)">
      <mat-icon svgIcon="more"></mat-icon>
    </button>
    <mat-menu #actionsMenu="matMenu" (closed)="isMenuOpened.set(false)">
      <button
        *ngIf="version?.release"
        class="tool-btn"
        mat-menu-item
        [disableRipple]="true"
        (click)="openTargetRelease()">
        {{ 'VERSIONING.OPEN_TARGET_RELEASE' | translate }}
      </button>

      <ng-container *ngIf="version.state === DIAGRAM_VERSION_STATES_ENUM.DRAFT">
        <button
          *ngIf="!isAuthorizationActive; else authorizationActive"
          class="tool-btn"
          mat-menu-item
          [disableRipple]="true"
          (click)="makeReadyForRelease()">
          {{ 'VERSIONING.MAKE_READY_FOR_RELEASE' | translate }}
        </button>

        <ng-template #authorizationActive>
          <button
            *ngIf="!version?.readyToAuthorise; else readyToAuthorise"
            class="tool-btn"
            mat-menu-item
            (click)="toggleReadyAuthorization(true)">
            {{ 'VERSIONING.MAKE_READY_FOR_AUTHORISATION' | translate }}
          </button>

          <ng-template #readyToAuthorise>
            <button
              class="tool-btn"
              mat-menu-item
              (click)="openSubmitForAuthorizationPopup()"
              [disabled]="isAuthorisationInProgress">
              {{ 'VERSIONING.REQUEST_AUTHORISATION' | translate }}
            </button>

            <button class="tool-btn" mat-menu-item (click)="toggleReadyAuthorization(false)">
              {{ 'VERSIONING.CANCEL_AUTHORISATION' | translate }}
            </button>
          </ng-template>
        </ng-template>
      </ng-container>
    </mat-menu>
  </div>

  <mat-divider></mat-divider>
</ng-container>
